import { useRef } from 'react';

let counter = 0;

export default function useId(prefix = 'tb') {
  const hasRun = useRef(false);
  const value = useRef(counter);

  if (!hasRun.current) {
    hasRun.current = true;
    counter += 1;
  }

  return `${prefix}-${value.current}`;
}
